export const clamp = (number: number, lower: number, upper: number): number => {
  return number > upper ? upper : number < lower ? lower : number;
};
